import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Global } from 'src/app/global/globalApi';
import { LoginDTO } from 'src/app/models/LoginDTO';
import { ApiService } from 'src/app/services/api.service';
import { DashboardBusinessLogicService } from 'src/app/services/dashboard-business-logic.service';
import { NewAgentApiService } from 'src/app/services/new-agent-api.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import { environment } from 'src/environments/environment';
import * as Constants from '../../models/Constants';
import { EncryptDecryptService } from '../../services/encrypt-decrypt.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  loginFormObj = new LoginDTO();
  iconConfigEye = {
    iconName: 'eye',
    iconType: 'fal',
  };
  iconConfigEyeSlash = {
    iconName: 'eye-slash',
    iconType: 'fal',
  };
  hidePwdIcon = true;
  inputDataType: string = '';
  disableLoginButton: boolean = false;
  accountNotBlocked: boolean = true;

  loginForm = new FormGroup({
    lanId: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
  });
  loadLoginPage: boolean = true;
  savientCldUrl = Constants.SAVIENT_CLD_URL;

  constructor(
    private router: Router,
    private apiService: NewAgentApiService,
    private route: ActivatedRoute,
    public rootScope: RootScopeService,
    public loginService: ApiService,
    private encrytDecryptService: EncryptDecryptService,
    private http: HttpClient,
    public dashboardService: DashboardBusinessLogicService,
  ) {

    let that = this;
    this.inputDataType= atob(Constants.DATA_TYPE.pinputType);
    if (this.route.snapshot.params?.['oldSessionId'] && this.route.snapshot.params?.['newSessionId']) {
      this.rootScope.oldSessionId = this.encrytDecryptService.decrypt(this.route.snapshot.params?.['oldSessionId']);
      this.rootScope.newSessionId = this.encrytDecryptService.decrypt(this.route.snapshot.params?.['newSessionId']);
      localStorage.setItem('userSession', this.rootScope.oldSessionId);
      sessionStorage.setItem('userSession', this.rootScope.oldSessionId);
      that.rootScope.isSSODuplicate = true;
    }
 
         
  }

  ngOnInit(): void {
    this.loadApplicationBySSO();   
  }

  /****
   * We have below 4 ways to launch our application
   * Case 1 :  SSO
   * Case 2 : Manual login
   * Case 3 & 4 : bookmark or right click and open duplicate tab
   *
   * @author :Pooja Gupta
   * 
   * Below method deals with LAUNCHING APP VIA SSO.
   * 
   * When application is launched successfully below url will be sent by backend:
   * http://localhost:4200/home/sso/16112E53F4CC4D46EB0600CF7994BBB4/pooja.gupta2@alight.com/
   * 
   * When SSO fails:
   * http://localhost:4200/ssoerror
   * 
   * When while launching app vis SSO ,backend figures out its a duplicate request
   * http://localhost:4200/home/sso/ValidateSession?oldSessionId=CA696B9085C132E6055FE7F71EA22369&newSessionId=3834E0F17E80D76F1579B90513C2A6E9
   */

  loadApplicationBySSO() { 
 
    if (this.route.snapshot.params['sessionId']) {
      this.loadLoginPage = false;
     let sessionIdBySSO = this.encrytDecryptService.decrypt(this.route.snapshot.params['sessionId']);
       let emailIdBySSO = this.encrytDecryptService.decrypt(this.route.snapshot.params['emailId']);

      let param={ 'sessionId': sessionIdBySSO, 'emailId': emailIdBySSO};
      this.apiService
        .postApi(Global.ssoLogin.validateSession, param, '','*', false)
        .subscribe({
          next: (res) => {
            if (res && res?.data?.statusCode <= 399) {
              this.rootScope.launchAppBySSO = true;
              this.rootScope.sessionId = param?.['sessionId'];
              this.rootScope.userLoggedIn = true;
              this.rootScope.emailId = param?.['emailId'];
              localStorage.setItem('userSession', param?.['sessionId']);
              localStorage.setItem('emailId', param?.['emailId']);
              sessionStorage.setItem('emailId', param?.['emailId']);
              sessionStorage.setItem("userSession", param?.['sessionId']);
              sessionStorage.setItem("browserSessionStartTimestamp", res.data?.['browserSessionStartTimestamp']);
              this.rootScope._isAuthenticated.next(true);
              this.loginService.getUserDetails();
              localStorage.removeItem('TBAGUIRegistrationnAuthorized');
              localStorage.removeItem('isConnected');
              localStorage.removeItem('TBAGUIStatusConnected');
              this.dashboardService.stopTbaConnectivityInterval();
                     

            } else {
              this.rootScope._isLogout.next(true);
              /****SSO Failing redirecting to login page *****/
              this.router.navigate(['/ssoerror']);
            }
          },
          error: (error) => {
           
            this.rootScope._isLogout.next(true);
            /****SSO Failing redirecting to login page *****/
            this.router.navigate(['/ssoerror']);
          },
        });
    }
    else if (this.rootScope.isSSODuplicate) {
      this.router.navigate(['/'])
    }

  }



  /**Below method handle the toggle of UI password eye/eye-slash on click of the icon */
 
  togglePwdIcon() {
    this.hidePwdIcon = !this.hidePwdIcon;
    this.hidePwdIcon
      ? (this.inputDataType = atob(Constants.DATA_TYPE.pinputType))
      : (this.inputDataType = Constants.DATA_TYPE.text);
  }

  /**Below method handle the Submit button click event of User Registration Form */
 
  onSubmit() {
    
    if (!this.loginForm.invalid) {
      this.login();
    } else {
    }
  }

  
  login() {
    let isTestUser :boolean = false;
    this.rootScope.loginAccountUnauthorizedError = false;
    this.rootScope.loginAccountBlockedError = false;
    this.rootScope.loginAccountUnexpectedError = false;
    this.accountNotBlocked = true;

    /** added for strees testing- Pooja - CCR1-6018  */
  
    if(this.loginForm.value.lanId && this.loginForm.value.lanId?.startsWith(Constants.LOAD_TEST_USER_ID) && this.loginForm.value.lanId?.endsWith(Constants.LOAD_TEST_ENDS_USER_ID) ){
      isTestUser = true;
      this.loginFormObj.lanId = this.loginForm.value.lanId ;
      this.loginFormObj.password =this.loginForm.value.password;
    }
    else{
      this.loginFormObj.lanId = this.encrytDecryptService.encrypt(this.loginForm.value.lanId);
      this.loginFormObj.password = this.encrytDecryptService.encrypt(this.loginForm.value.password);
    }

  
    this.loginService.login(this.loginFormObj , isTestUser).subscribe({
      next: (data: any) => {
     
        console.log('res', data);
        if (data?.httpStatusCode == 200) {
          let res = data?.data;
          this.rootScope.isDuplicateSession = res?.isDuplicate;
          this.rootScope.sessionId = res?.jsessionId;
          this.rootScope.userLoggedIn = true;
          this.rootScope.emailId = res?.emailId;
          this.rootScope.launchAppFromManualLogin = true;
          this.rootScope.browserSessionStartTimestamp = res?.browserSessionStartTimestamp;
          this.rootScope._isAuthenticated.next(true);
          this.loginService.getUserDetails();
          localStorage.removeItem('TBAGUIRegistrationnAuthorized');
          localStorage.removeItem('isConnected');
          localStorage.removeItem('TBAGUIStatusConnected');
          
       
          this.loginService.updateLandId(this.loginForm.value.lanId?.toUpperCase());
           localStorage.removeItem('TBAGUIRegistrationnAuthorized');
           localStorage.removeItem('isConnected');
           localStorage.removeItem('TBAGUIStatusConnected');
           this.dashboardService.stopTbaConnectivityInterval();
            
          if (this.rootScope.createNameForUserProfile(res?.firstName, res?.lastName, res?.lanId, res?.browserSessionStartTimestamp,res?.emailId))
            this.router.navigate(['/']);
        }

      },
      error: (error: any) => {
        if (
          error?.error?.httpStatusCode == 401 &&
          error?.error?.httpStatus == 'UNAUTHORIZED'
        ) {
          this.rootScope.loginAccountUnauthorizedError = true;
          this.rootScope.loginAccountBlockedError = false;
          this.rootScope.loginAccountUnexpectedError = false;
        } else if (
          error?.error?.httpStatusCode == 423 &&
          error?.error?.httpStatus == 'LOCKED'
        ) {
          this.rootScope.loginAccountUnauthorizedError = false;
          this.rootScope.loginAccountBlockedError = true;
          this.rootScope.loginAccountUnexpectedError = false;
          this.accountNotBlocked = false;
          this.loginForm.reset();
          this.disableLoginButton = true;
          this.loginForm.disable();
        } else {
          this.rootScope.loginAccountUnauthorizedError = false;
          this.rootScope.loginAccountUnauthorizedError = false;
          this.rootScope.loginAccountUnexpectedError = true;
        }
      },
    });
  }

  launchUtility() {
    this.rootScope.tbawindow.set(this.rootScope.sessionId, window.open(Constants.TBA_LOGIN_URL, '_self'));
  }
}
